import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";
import {OddsCellDomainModel} from "./odds-cell.domain-model";
import {observable, makeObservable} from "mobx";

export class OddsCellViewModel extends BaseViewModel {
  @observable text: String;
  isBold: Boolean;

  constructor(model: OddsCellDomainModel) {
    super(model);

    this.text = model.text;
    this.isBold = model.isBold;

    makeObservable(this);
  }
}
